export default function getTimezoneOffset() {
    return new Date().getTimezoneOffset();
}
